<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import ButtonAddToItinerary from '$lib/components/atoms/button/ButtonAddToItinerary.svelte';
	import * as m from '$paraglide/messages';
	import datasheetLocationImgUrl from './datasheetLocationImg.webp';

	interface Props {
		address?: string;
		onAddItineraryClick?: () => void;
		seeOnMap?: () => void;
	}

	const { address, onAddItineraryClick, seeOnMap }: Props = $props();

	// TODO: temporary, itinerary button will be featured in next design iterations
	const showItineraryButton = false;
</script>

<div
	role="button"
	tabindex="0"
	class="w-full shadow-smooth-bottom-4 rounded-3xl border border-neutral-soft bg-neutral-weakest flex items-center gap-x-4 p-4 cursor-pointer max-w-432px mx-2"
	onclick={seeOnMap}
	onkeypress={(event) => {
		if (event.key === 'Enter') {
			seeOnMap?.();
		}
	}}
>
	<div class="relative flex-shrink-0">
		<img src={datasheetLocationImgUrl} alt="location" class="rounded-2xl size-22" />
		<span
			class="icon-pin inline-block h-5 absolute top-1/2 left-1/2 -translate-1/2 shadow-smooth-block"
		></span>
	</div>
	<div class="flex flex-col gap-y-2">
		<div class="font-semibold text-md">{m.poi_datasheet__location()}</div>
		{#if address}
			<div class="text-body text-sm clamp-lines-1">{address}</div>
		{/if}
		<div class="flex items-center gap-x-2">
			{#if showItineraryButton}
				<ButtonAddToItinerary
					variant="filled"
					color="light"
					class="text-sm"
					size="sm"
					onclick={(event) => {
						event.stopPropagation();
						onAddItineraryClick?.();
					}}
				/>
			{/if}
			<Button
				size="sm"
				variant="filled"
				color="white"
				text={m.poi_datasheet__see_on_map()}
				class="text-sm hidden md:inline-block"
				onclick={(event) => {
					event.stopPropagation();
					seeOnMap?.();
				}}
			/>
		</div>
	</div>
</div>
